const PUBLIC_ROUTES = [
  "/login",
  "/docs-access-frame",
  "/login/mfa",
  "/activate",
  "/change/password",
  "/forgot/password",
  "/onboarding",
  "/help",
  "/help/dictionary",
  "/report/bug",
  "/approve-quote",
  "/approve-proposal",
];

export default PUBLIC_ROUTES;
